import styled from "styled-components";

export const PageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ChartCard = styled.div`
  border-radius: 12px;
  border: 1px solid #e9eaeb;
  padding: 20px;
`;

export const ContentGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RightSidebarWrapper = styled.div`
  @media (max-width: 991px) {
    margin-top: 24px;
  }
`;
